import React from 'react';
import { HeaderNavButtons, HeaderTitle, HeaderSearch } from 'App/Header'
import styles from './Header.module.css';
import { RefreshRequired } from './RefreshRequired.js'
import { connect } from 'react-redux';

class ScreenHeader extends React.Component {
    render() {
        return (
            <>
                <div className={styles.header} style={{ backgroundColor: ['development', 'qa'].includes(process.env.REACT_APP_ENV) ? 'lightgrey' : process.env.REACT_APP_ENV === 'staging' ? 'pink' : '' }}>
                    <div className={styles.header_navbuttons}>
                        <HeaderNavButtons />
                    </div>
                    <div className={styles.header_title}>
                        <HeaderTitle />
                    </div>
                    <div className={styles.header_search}>
                        <HeaderSearch />
                    </div>
                </div>
                {this.props.refreshRequired &&
                    <RefreshRequired />
                }
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        refreshRequired: state.ui.refresh.refreshRequired
    };
}


const connectedScreenHeader = connect(mapStateToProps)(ScreenHeader);
export { connectedScreenHeader as ScreenHeader };



